import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, sub, dark = false, align = "left" }) => (
  <Reveal className={`mb-12 sm:mb-16 ${align === "center" ? "text-center" : ""}`}>
    <p
      className={`font-mono text-xs sm:text-sm tracking-[0.3em] uppercase mb-4 ${
        dark ? "text-[#D4A359]" : "text-[#5C3A21]"
      }`}
    >
      {eyebrow}
    </p>
    <h2
      className={`text-3xl sm:text-4xl lg:text-5xl font-serif font-bold tracking-tight leading-[1.1] ${
        dark ? "text-[#FAF6EE]" : "text-[#2C1A0C]"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p
        className={`mt-5 text-base sm:text-lg leading-relaxed max-w-2xl ${
          dark ? "text-[#FAF6EE]/70" : "text-[#6E5B4F]"
        } ${align === "center" ? "mx-auto" : ""}`}
      >
        {sub}
      </p>
    )}
  </Reveal>
);
